<template>
  <v-list>
    <v-list-item link v-if="user">
      <v-list-item-title class="text-h6">{{user.fullName}}</v-list-item-title>
      <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
    </v-list-item>
    <v-list-item>
      <v-btn variant="outlined" to="/me" block class="mb-2">Minu seaded</v-btn>
      <v-btn color="black" href="/auth/logout" block>Logi välja</v-btn>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user'])
  }
}
</script>
